import { MemberLevel } from '@/enums/member'

export const isVIP = (lv) => {
  return (typeof lv !== 'undefined' && lv > MemberLevel.Seeker)
}
